import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number, initialSeconds: number) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds)
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true)
      return
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timerId)
  }, [timeLeft])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(seconds).padStart(2, '0')

  return {
    minutes: formattedMinutes,
    seconds: formattedSeconds,
    isExpired,
  }
}
